import { createAction, props } from '@ngrx/store';

export enum DetalleFacturaActionTypes {
    DetalleFactura = '[Factura] DetalleFactura',
    DetalleFacturaLimpiar = '[Factura] DetalleFactura',
}

export const DetalleFactura = createAction(DetalleFacturaActionTypes.DetalleFactura, props<{ params:any}>());
//export const DetalleFacturaLimpiar = createAction(DetalleFacturaActionTypes.DetalleFacturaLimpiar);
